export default __webpack_public_path__ + "static/media/video_blue.893d5ee5.png";